import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import { getSlidersByPageCode } from '../../api/sliderService';
import {
  CaretLeftIcon,
  CaretRightIcon,
  FacebookIcon,
  InstagramIcon,
  TiktokIcon,
  XIcon,
  YoutubeIcon,
} from '../../components/Icons/SiteIcons';

export default function Hero() {
  const [sliderItems, setSliderItems] = useState([]);

  useEffect(() => {
    const fetchSliders = async () => {
      try {
        const response = await getSlidersByPageCode('MainPage');
        if (response.isSuccess && response.data) {
          setSliderItems(response.data);
        }
      } catch (error) {
        console.error('Slider verisi yüklenirken hata oluştu:', error);
      }
    };

    fetchSliders();
  }, []);

  // --- Yeni sekmede aç ---
  const openSlideUrl = (item) => {
    const url = item?.url || item?.link;
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  // --- Drag / Click ayrımı ---
  const isDraggingRef = useRef(false);
  const downPosRef = useRef({ x: 0, y: 0 });
  const DRAG_THRESHOLD = 6; // px

  const handlePointerDown = (e) => {
    const p = 'touches' in e ? e.touches[0] : e;
    downPosRef.current = { x: p.clientX, y: p.clientY };
    isDraggingRef.current = false;
  };

  const handlePointerMove = (e) => {
    const p = 'touches' in e ? e.touches[0] : e;
    const dx = Math.abs(p.clientX - downPosRef.current.x);
    const dy = Math.abs(p.clientY - downPosRef.current.y);
    if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
      isDraggingRef.current = true;
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: sliderItems[0]?.intervalSecond || 5000,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    appendDots: (dots) => (
      <div style={{ position: 'absolute', bottom: '20px', width: '100%' }}>
        <ul>{dots}</ul>
      </div>
    ),
    // drag sinyalini slick'ten de alalım
    onSwipe: () => {
      isDraggingRef.current = true;
    },
    beforeChange: () => {
      isDraggingRef.current = true;
    },
    afterChange: () => {
      isDraggingRef.current = false;
    },
  };

  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <CaretRightIcon size={40} color="rgb(8, 73, 119)" />
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <CaretLeftIcon size={40} color="rgb(8, 73, 119)" />
      </div>
    );
  }

  return (
    <div className="hero">
      <div className="row">
        <div className="col-12 col-md-8">
          <Slider {...settings} className="hero-swiper">
            {Array.isArray(sliderItems) &&
              sliderItems.map((item, index) => (
                <div key={item.guid ?? index}>
                  <div
                    className="hero-slider"
                    // drag takibi (mouse + touch)
                    onMouseDown={handlePointerDown}
                    onMouseMove={handlePointerMove}
                    onTouchStart={handlePointerDown}
                    onTouchMove={handlePointerMove}
                    // tıklama: sadece drag yapılmadıysa
                    onClick={() => {
                      if (isDraggingRef.current) return;
                      openSlideUrl(item); // yeni sekmede
                    }}
                    role="link"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') openSlideUrl(item);
                    }}
                    aria-label={
                      item.header ? `${item.header} – detaya git` : 'Detaya git'
                    }
                  >
                    <img
                      src={item.fileUrl}
                      alt={item.header || ''}
                      className="hero-slider-image"
                      loading="lazy"
                      draggable={false}
                    />
                    <div className="hero-slider-content">
                      <p>{item.header}</p>
                      <p>{item.shortDetail || item.detail}</p>
                    </div>

                    <div className="hero-slider-overlay"></div>

                    {(item.link || item.url) && (
                      <div className="hero-slider-button">
                        {/* <a
                          href={item.link || item.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Detaya Git
                        </a> */}
                      </div>
                    )}
                  </div>
                </div>
              ))}
          </Slider>
        </div>

        <div className="col-12 col-md-4">
          <div className="mayorBox">
            <div className="mayorBox_image">
              <a href="/baskan">
                <img src="assets/images/mayor.jpg?v=626" alt="" />
              </a>
            </div>
            <div className="mayorBox_info">
              <div className="mayorBox_info-left">
                <a href="/baskan" className="mayor-info-link">
                  <div className="mayorBox_name">
                    <h3>Mehmet Dönmez</h3>
                  </div>
                  <div className="mayorBox_position">
                    <h4>İskenderun Belediye Başkanı</h4>
                  </div>
                </a>
              </div>
              <div className="mayorBox_info-right">
                <div className="mayorBox_social">
                  <ul>
                    <li>
                      <button onClick={() => window.open('https://www.instagram.com/mehmetdonmezisk/', '_blank')}>
                        <InstagramIcon />
                      </button>
                    </li>
                    <li>
                      <button onClick={() => window.open('https://www.youtube.com/@mehmetdonmezisk', '_blank')}>
                        <YoutubeIcon />
                      </button>
                    </li>
                    <li>
                      <button onClick={() => window.open('https://x.com/mehmetdonmezbb', '_blank')}>
                        <XIcon />
                      </button>
                    </li>
                    <li>
                      <button onClick={() => window.open('https://www.facebook.com/mehmetdonmezofficial', '_blank')}>
                        <FacebookIcon />
                      </button>
                    </li>
                    <li>
                      <button onClick={() => window.open('https://www.tiktok.com/@mehmetdonmezbb', '_blank')}>
                        <TiktokIcon />
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
